import React from 'react';

import './global.css';

import Routes from './routes/routes';

const App = () => (
  <div className="App">
    <Routes />
  </div>
);

export default App;
